import axios from 'axios';

export default {
    async fetchAllProfessions() {
        return axios.get('/professions');
    },

    async fetchCompanies() {
        return axios.get('/companies');
    },

    async fetchAllWorkerQualifications() {
        return axios.get('/workers/qualifications');
    },

    async fetchAllRegions() {
        return axios.get('/nomenclatures/regions');
    },

    async fetchAllGeneralStatuses() {
        return axios.get('/general-statuses');
    },

    async fetchAllLanguages() {
        return axios.get('/nomenclatures/languages');
    },

    async fetchCountries() {
        return axios.get('/nomenclatures/countries');
    },

    async fetchCarEnums() {
        return axios.get('/nomenclatures/car-enums');
    },

    async fetchUserRoles() {
        return axios.get('/nomenclatures/user-roles');
    },

    async addProfession(profession) {
        return axios.post('/professions',
            profession,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateProfession(profession) {
        return axios.put('/professions',
            profession,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async addCompany(company) {
        return axios.post('/companies',
            company,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateCompany(company) {
        return axios.put('/companies',
            company,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },
}
